import { render, staticRenderFns } from "./NFse.vue?vue&type=template&id=4ef83ba0"
import script from "./NFse.vue?vue&type=script&lang=js"
export * from "./NFse.vue?vue&type=script&lang=js"
import style0 from "./NFse.vue?vue&type=style&index=0&id=4ef83ba0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports